<template>
  <div class="text-center py-5" v-if="isRoundLock === null">
    <p class="mt-4 text-secondary">Loading ...</p>
  </div>

  <v-card v-if="!is_authorized_officer && isRoundLock === true">
    <div class="text-center pt-8 pb-16">
      <h1 class="mt-4">{{ $t("main.round_locked") }}</h1>
    </div>
  </v-card>

  <v-card
    max-width="750"
    class="mx-auto"
    :disabled="loading"
    :loading="loading"
    v-if="is_authorized_officer || isRoundLock === false"
  >
    <v-toolbar color="primary">
      <v-toolbar-title>
        <h1>{{ $t("info.system") }}</h1>
      </v-toolbar-title>
      <v-btn
        elevation="3"
        class="float-right mr-4"
        color="#9D00FF"
        variant="flat"
        to="/main_officer"
        append-icon="mdi-account-switch"
        v-if="is_authorized_officer"
        >ตรวจรายงานตัว
      </v-btn>
    </v-toolbar>

    <h1 class="text-center pt-5">
      {{ objectTranslator(surrogated_student_info, "STUDENT_FNAME") }}
      {{ objectTranslator(surrogated_student_info, "STUDENT_LNAME") }}
    </h1>
    <h2 class="text-center py-2">
      {{ $t("main.status") }}:
      <v-chip :color="show_matriculation_status_color">
        <h2>
          {{
            inlineTranslator({
              th: show_matriculation_status_TH,
              en: show_matriculation_status_EN,
            })
          }}
        </h2>
      </v-chip>
    </h2>

    <v-card
      v-if="surrogated_student_info.MATRICULATION_STATUS_ID == 2"
      class="rounded-shaped bg-error mx-auto mb-3"
      elevation="3"
      width="700"
      style="border: 3px solid #b22222"
    >
      <v-card-item class="custom-text">
        <v-card-title class="mt-2">
          <h1>
            <v-icon>mdi-alert-circle</v-icon>
            {{ $t("main.comment") }}
          </h1>
        </v-card-title>
        <v-card-text class="ml-5">
          <div v-show="!is_lock_photo" class="mt-3">
            <span class="font-weight-bold">
              <v-icon class="mdi-rotate-270">mdi-triangle-small-down</v-icon>
              {{ $t("main.has_comment_for_photo") }} {{ commentPhoto }}
              <v-btn
                class="text-none ml-1 my-auto"
                color="#f8d7da"
                variant="flat"
                elevation="2"
                size="x-small"
                to="/page8"
              >
                Click
              </v-btn>
            </span>
          </div>
          <div v-show="!is_lock_document" class="mt-3">
            <span class="font-weight-bold">
              <v-icon class="mdi-rotate-270">mdi-triangle-small-down</v-icon>
              {{ $t("main.has_comment_for_document") }}
              <v-btn
                class="text-none ml-1 my-auto"
                color="#f8d7da"
                variant="flat"
                elevation="2"
                size="x-small"
                to="/page9"
              >
                Click
              </v-btn>
            </span>
          </div>
        </v-card-text>
      </v-card-item>
    </v-card>

    <v-card
      max-width="700px"
      height="100%"
      class="mx-auto my-5"
      elevation="0"
      variant="outlined"
    >
      <v-card-title class="text-h3">
        {{ $t("main.step_of_marticulation") }}
      </v-card-title>
      <v-card-text>
        <p>
          {{ $t("main.step_of_marticulation_detail") }}<br /><br />
          {{ $t("main.step_of_marticulation_1") }}<br />
          {{ $t("main.step_of_marticulation_2") }}<br />
          {{ $t("main.step_of_marticulation_3") }}<br />
          {{ $t("main.step_of_marticulation_4") }}<br />
          {{ $t("main.step_of_marticulation_5") }}
        </p>
      </v-card-text>
    </v-card>

    <Timeline
      :allPageStatus="allPageStatus"
      :is_lock_kmitl1="is_lock_kmitl1"
      :is_lock_photo="is_lock_photo"
      :is_lock_document="is_lock_document"
      :level_id="surrogated_student_info.LEVEL_ID"
    />

    <v-card
      max-width="700px"
      class="mx-auto my-5"
      elevation="0"
      variant="outlined"
    >
      <v-card-actions class="d-flex justify-center mt-2">
        <v-btn
          :disabled="is_can_commit === false"
          :color="is_can_commit === false ? 'gray' : 'indigo-darken-3'"
          :loading="loading"
          class="text-none px-5"
          variant="flat"
          size="x-large"
          rounded="lg"
          @click="confirmCommit"
        >
          {{ $t("main.confirm_commit") }}
        </v-btn>
      </v-card-actions>
      <v-card-text class="pt-0 pb-4">
        <h5 class="text-red-lighten-1">{{ $t("main.remark") }}</h5>
        <p class="text-red-lighten-1">{{ $t("main.remark_1") }}</p>
        <p class="text-red-lighten-1">{{ $t("main.remark_2") }}</p>
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
import {
  inlineTranslator,
  objectTranslator,
  dateTimeFromDBTranslatorFull as dt,
} from "@/helper/translator";
import Timeline from "@/views/prestudent/components/Timeline.vue";
import UserProvider from "@/services/user.provider";
import { listFilter, getById } from "@/helper/filter";

const userService = new UserProvider();

export default {
  name: "MainView",
  data: () => ({
    loading: false,
    tabs: "section1",
    allPageStatus: [0, 0, 0, 0, 0, 0, 0, 0, 0],
    matriculation_statuses: [],
    levels: [
      {
        LEVEL_ID: "1",
        LEVEL_NAME_EN: "Undergraduate",
        LEVEL_NAME_TH: "ปริญญาตรี",
      },
      {
        LEVEL_ID: "2",
        LEVEL_NAME_EN: "Postgraduate",
        LEVEL_NAME_TH: "บัณฑิตศึกษา",
      },
    ],

    show_matriculation_status_TH: null,
    show_matriculation_status_EN: null,
    show_matriculation_status_color: null,
    show_detail_amend: [],
    is_complete_upload_document: false,

    commentPhoto: null,

    isRoundLock: null,
  }),
  components: {
    Timeline,
  },
  computed: {
    uid() {
      return this.$store.state.user.surrogated_student_uid;
    },

    is_authorized_officer() {
      return this.$store.state.user.is_authorized_officer;
    },

    surrogated_student_info() {
      return this.$store.state.user.surrogated_student_info;
    },

    is_lock_kmitl1() {
      let data = true;
      let LOCK_KMITL1 = parseInt(
        this.$store.state.user.surrogated_student_info.LOCK_KMITL1
      );
      if (LOCK_KMITL1 === 0) {
        data = false;
      }
      return data;
    },
    is_lock_photo() {
      let data = true;
      let LOCK_PHOTO = parseInt(
        this.$store.state.user.surrogated_student_info.LOCK_PHOTO
      );
      if (LOCK_PHOTO === 0) {
        data = false;
      }
      return data;
    },
    is_lock_document() {
      let data = true;
      let LOCK_UPLOAD = parseInt(
        this.$store.state.user.surrogated_student_info.LOCK_UPLOAD
      );
      if (LOCK_UPLOAD === 0) {
        data = false;
      }
      return data;
    },

    is_complete_all_page() {
      return this.allPageStatus.every((value) => value == 1);
    },
    is_complete_upload_photo() {
      let data = false;
      if (
        this.$store.state.user.surrogated_student_info
          .UPLOAD_STUDENT_CARD_PHOTO_STATUS === "1"
      ) {
        data = true;
      }
      return data;
    },
    is_can_commit() {
      //สามารถกด "ส่งผลตรวจการรายงานตัว" ได้เมื่อ ข้อมูลครบทั้ง 3 ส่วน และ สถานะเป็น "ยังไม่สมบูรณ์" หรือ "ไม่ผ่าน"
      let data = false;
      if (
        this.is_complete_all_page &&
        this.is_complete_upload_document &&
        this.is_complete_upload_photo &&
        (this.surrogated_student_info.MATRICULATION_STATUS_ID == 0 ||
          this.surrogated_student_info.MATRICULATION_STATUS_ID == 2)
      ) {
        data = true;
      }
      return data;
    },
  },

  methods: {
    dt,
    getById,
    listFilter,
    objectTranslator,
    inlineTranslator,
    toggle_loading(status) {
      this.loading = status;
    },

    async confirmCommit() {
      this.loading = true;
      const response = await userService
        .setMatriculationStatus({
          uid: this.uid,
          value: "1",
        })
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.loading = false;
        });
      if (response && response.status) {
        this.$toast.success(this.$t("toast.save_successfully"));
        await this.$store.dispatch("user/getUserInfo");
        this.fetch_data();
      } else this.$toast.error(this.$t("toast.cannot_save"));
      this.loading = false;
    },

    async getMatriculationStd() {
      const ref_data = await userService
        .getMatriculationStatusStd(this.uid)
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
        });

      this.show_matriculation_status_TH = ref_data.MATRICULATION_STATUS_NAME_TH;
      this.show_matriculation_status_EN = ref_data.MATRICULATION_STATUS_NAME_EN;
      this.show_matriculation_status_color = ref_data.TEXT_CLASS;
    },

    async getStatusTimeline() {
      this.loading = true;
      const entered_page =
        this.$store.state.user.surrogated_student_info.ENTERED.substring(
          1
        ).split(",");

      for (var i = 0; i < entered_page.length; i++) {
        entered_page[i] == i + 1
          ? (this.allPageStatus[i] = 1)
          : (this.allPageStatus[i] = 0);
      }

      const data = await userService
        .getOverallUploadStatus(this.uid)
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
        });
      this.is_complete_upload_document = data.status;

      this.allPageStatus[7] = parseInt(
        this.$store.state.user.surrogated_student_info
          .UPLOAD_STUDENT_CARD_PHOTO_STATUS
      );
      this.allPageStatus[8] = +this.is_complete_upload_document;

      this.loading = false;
    },

    async getStatusAndCommentPhoto() {
      const commentPhoto = await userService
        .getStatusAndCommentPhoto(this.uid)
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
        });
      this.commentPhoto = commentPhoto.COMMENT_PHOTO;
    },

    async getRoundLock() {
      const level_id = this.surrogated_student_info.LEVEL_ID;
      const data = await userService.isRoundLock(level_id).catch((error) => {
        this.$toast.error(JSON.stringify(error.response.data.message));
      });
      if (data) this.isRoundLock = data.status;
    },

    async fetch_data() {
      await this.$store.dispatch("user/getUserInfo");
      this.getRoundLock();
      this.getMatriculationStd();
      this.getStatusTimeline();
      this.getStatusAndCommentPhoto();
    },
  },

  created() {
    this.fetch_data();
  },
};
</script>

<style scoped>
span {
  font-size: 16px !important;
}

.inline-h2 {
  color: black;
}

.card-todo-list {
  /* background-color: #3b3939; */
  /* color: wheat; */
  max-width: 1250px;
}

.custom-text {
  color: #f8d7da;
}
</style>
